/** Curated color values offered by `color` and `accent_color` fields.
 *
 * These are product data choices, not application themes: selecting one no
 * longer replaces the default `@llui/components` palette. */
export const CAMPAIGN_ACCENTS = [
  'amber',
  'aubergine',
  'forest',
  'indigo',
  'oxblood',
  'slate',
  'teal',
] as const;

export type CampaignAccent = (typeof CAMPAIGN_ACCENTS)[number];

export interface CampaignAccentSwatch {
  accent: CampaignAccent;
  hex: string;
}

export const CAMPAIGN_ACCENT_SWATCHES: readonly CampaignAccentSwatch[] = [
  { accent: 'amber', hex: '#a8650a' },
  { accent: 'aubergine', hex: '#5c2e5c' },
  { accent: 'forest', hex: '#2e5c3a' },
  { accent: 'indigo', hex: '#2e3768' },
  { accent: 'oxblood', hex: '#6b2f2f' },
  { accent: 'slate', hex: '#4a5560' },
  { accent: 'teal', hex: '#3a6f6f' },
];
